import React from 'react';
import { t } from '../i18n';

// ─── Плитки: один шаблон главного экрана на всю программу ────────────────────
//
// У кладовщика есть экран из трёх больших плиток — «три дела». Он единственный,
// про который никто не спрашивал, что тут нажимать: работа названа делом, рядом
// стоит число ждущего, и промахнуться пальцем невозможно.
//
// Остальные роли жили иначе: у технолога в одном столбце висело тринадцать
// разделов, у администратора двадцать пять пунктов. Каждодневное и то, что
// открывают раз в месяц, стояло одним шрифтом и одной толщиной — глазу не за
// что зацепиться, и человек спрашивал, куда нажимать, каждый раз заново.
//
// Поэтому шаблон один: главный экран — это дела, которые делают сегодня, с
// числом ждущего. Всё, что реже раза в неделю, уходит за одну дверь
// «Справочники». Здесь только оболочка, чтобы экраны не расходились по виду.

export function TileGrid({ tiles, onPick, min = 280 }) {
  return (
    <div style={{
      display: 'grid', gap: 14,
      gridTemplateColumns: `repeat(auto-fit, minmax(${min}px, 1fr))`,
    }}>
      {(tiles || []).filter(Boolean).map(x => (
        <button key={x.key} onClick={() => onPick(x.key)} className="touch-btn" style={{
          display: 'flex', flexDirection: 'column', alignItems: 'flex-start',
          gap: 8, textAlign: 'left', width: '100%', minHeight: x.small ? 108 : 156,
          background: 'var(--card)', border: '1px solid var(--border)',
          borderLeft: `5px solid ${x.color || 'var(--accent)'}`, borderRadius: 16,
          padding: x.small ? '16px 18px' : '20px 22px',
          cursor: 'pointer', fontFamily: 'inherit',
        }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 12, width: '100%' }}>
            <span style={{ fontSize: x.small ? 26 : 34, lineHeight: 1 }}>{x.icon}</span>
            {/* Число ждущего — то, ради чего сюда смотрят издалека: видно, есть
                ли работа, ещё не подойдя к столу */}
            {x.count > 0 && (
              <span style={{
                marginLeft: 'auto', background: x.color || 'var(--accent)', color: '#fff',
                borderRadius: 22, minWidth: 44, padding: '4px 14px',
                fontSize: x.small ? 15 : 20, fontWeight: 800, textAlign: 'center',
              }}>{x.count}</span>
            )}
          </div>
          <div style={{ color: 'var(--text)', fontSize: x.small ? 16 : 21, fontWeight: 800 }}>
            {t(x.title)}
          </div>
          {x.hint && (
            <div style={{ color: 'var(--muted)', fontSize: 13.5, lineHeight: 1.45 }}>
              {t(x.hint)}
            </div>
          )}
        </button>
      ))}
    </div>
  );
}

// Одна кнопка назад. Уйти с любого экрана можно одним нажатием и всегда в одно
// и то же место — иначе человек ищет выход там, где его в прошлый раз нашёл.
export function BackHome({ onBack, label = '← К главному' }) {
  return (
    <button onClick={onBack} className="touch-btn" style={{
      display: 'inline-flex', alignItems: 'center', gap: 8, marginBottom: 16,
      background: 'var(--card)', border: '1px solid var(--border)',
      borderRadius: 12, color: 'var(--muted)', padding: '10px 18px',
      fontSize: 14, fontWeight: 700, cursor: 'pointer', fontFamily: 'inherit',
    }}>{t(label)}</button>
  );
}

// Заголовок раздела над плитками — чтобы «Справочники» не выглядели такой же
// работой, как дела на главном экране.
export function TilesHead({ title, hint }) {
  return (
    <div style={{ marginBottom: 16 }}>
      <div style={{ color: 'var(--text)', fontSize: 20, fontWeight: 800 }}>{t(title)}</div>
      {hint && (
        <div style={{ color: 'var(--dim)', fontSize: 13.5, marginTop: 4 }}>{t(hint)}</div>
      )}
    </div>
  );
}
